let API_BASE_URL = "";

try {
    API_BASE_URL = process.env.PREACT_APP_API_BASE_URL || "";
} catch (error: unknown) {
    console.warn(
        "Pay attention: some of required environment variables are missing"
    );
}

export { API_BASE_URL };
